import { SearchIcon, RepeatIcon, ShuffleIcon, UsersIcon, DumbbellIcon, CalendarClockIcon } from 'lucide-react';

export const painPoints = [
  { icon: SearchIcon, text: 'Searching for exercises between classes.' },
  { icon: RepeatIcon, text: 'Repeating familiar circuits because preparation time is short.' },
  { icon: ShuffleIcon, text: 'Pulling workouts from different places without a clear progression.' },
  { icon: UsersIcon, text: 'Reworking sessions for different ability levels.' },
  { icon: DumbbellIcon, text: 'Planning around equipment availability.' },
  { icon: CalendarClockIcon, text: 'Spending your weekend deciding what comes next.' },
];
